import type * as React from 'react';
import { get } from '@Domain/Api';
import subjectTypeAccessLevelsFetched, {
	type SubjectTypeAccessLevelsFetchedAction,
	type SubjectTypeAccessLevelsFetchedPayload,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeAccessLevelsFetched';
import subjectTypeAccessLevelsFetchFailed, {
	type SubjectTypeAccessLevelsFetchFailedAction,
} from '@Application/SubjectTypeDefinitions/Actions/subjectTypeAccessLevelsFetchFailed';
import type FetchSubjectTypeAccessLevels from '@Application/SubjectTypeDefinitions/Queries/FetchSubjectTypeAccessLevels';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../parameters';

type Actions = SubjectTypeAccessLevelsFetchedAction | SubjectTypeAccessLevelsFetchFailedAction;

export default (_query: FetchSubjectTypeAccessLevels) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<SubjectTypeAccessLevelsFetchedPayload>(
				`${parameters.api.host}/api/enums/subject-type-access-levels`,
			);

			const action = subjectTypeAccessLevelsFetched(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = subjectTypeAccessLevelsFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
